import React,{ useEffect, useState} from 'react';
import handShake from '../../../../assets/img/clips-imgs/clip-handshake.svg';
import clipsTimer from '../../../../assets/img/clips-imgs/clip-timer.svg';
import { fundraiserPostDetails as fundraiserPostDetailsApi } from '../../../../api';
import { useParams } from 'react-router-dom';
const FundraisersTextSection = () => {
    const [ fundraiserSinglePost, setFundraserSinglePost ] = useState([])
    const params = useParams()
    useEffect( ()=>{
        fundraiserPostDetailsApi().then( data => setFundraserSinglePost(data[Number(params.id)]))
    }, [])
    console.log("Fundraisers single Data",fundraiserSinglePost)
    return (
        <div className="col-12 col-lg-5">
            <div className="row gap-3 mb-4">
                <div className="col-12">
                    {
                        fundraiserSinglePost?.tags?.map(( item, index ) => <div className="rounded-pill d-inline-flex justify-content-center align-items-center bd_tags me-2" key={index}> <span className="txt_wa" > {item} </span>  </div>)
                    }
                </div>
                <div className="col-12">
                    <h1 className="mb-0 fr_h">{fundraiserSinglePost?.clipTitle}</h1>
                </div>
                <div className="col-12">
                    <p className="mb-1 fr_para">
                    {fundraiserSinglePost?.fundingRejon}
                    </p>
                </div>
                <div className="col-12 d-flex justify-content-start align-items-center gap-2">
                    <img className="rounded-circle" src={fundraiserSinglePost?.authorIcon} alt='' />
                        <span className="txt_wa">{fundraiserSinglePost?.authName}</span>
                </div>
            </div>
            <div className="row gap-4 mb-4">
                <div className="col-12 col-xl-10 d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <img src={handShake} alt='' />
                        <div>
                            <span className="fr_num">{fundraiserSinglePost?.backers}&nbsp;</span><span className="fr_left">backers </span>
                        </div>
                    </div>
                    <div className="h-100 clip-timer"></div>
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <img src={clipsTimer} alt='' />
                        <div>
                            <span className="fr_num left-day-count">{fundraiserSinglePost.dayLeft}&nbsp;</span>
                            <span className="fr_left">days left </span>
                        </div>
                    </div>
                    <div></div>
                </div>
                <div className="col-12">
                    <div className="row gap-2">
                        <div className="col-12 d-flex justify-content-between">
                            <span className="txt_wa">${fundraiserSinglePost?.total}</span>
                            <span className="fr_total">${fundraiserSinglePost?.needed}</span>
                        </div>
                        <div className="col-12 d-flex justify-content-between">
                            <div className="progress w-100 rounded-pill prograce-bar-div-custom">
                                <div className="progress-bar custom-prograse-bar" aria-valuenow="36" aria-valuemin="0" aria-valuemax="100" style={{width: `${(fundraiserSinglePost?.total/fundraiserSinglePost?.needed)*100}%`}}><span className="visually-hidden">60%</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 d-flex justify-content-between">
                            <span className="fr_raised">{(fundraiserSinglePost?.total/fundraiserSinglePost?.needed)*100}% raised</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <button className="w-100 fund_btn rounded-pill backproject-button custm-pill-button-small" type="button">
                        Back this project
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FundraisersTextSection;